module.exports = __webpack_public_path__ + "static/far-cry_banner-3f665d6bccdb54ff3527b51b22547fd4.avif";